import * as React from "react";
function PassDistributionIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return <svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M9.39998 3.1H3C1.89543 3.1 1 3.99543 1 5.1V18.6C1 19.7046 1.89543 20.6 3 20.6H11.6C12.7045 20.6 13.6 19.7046 13.6 18.6V6.25" stroke={props.stroke || "black"} strokeLinecap="round" />
            <path d="M6.52637 9.10526L15 1M15 1H10.9474M15 1V4.82237" stroke={props.stroke || "black"} strokeLinecap="round" />
        </svg>;
}
export default PassDistributionIcon;